// source: https://shopline.atlassian.net/wiki/spaces/EN/pages/4864245772/Shop+Sentry+Tag
export const SOURCE = {
  angular: 'angular', // errors thrown by AngularJS modules
  manually: 'manually', // errors captured by explicit loggerService calls
  react: 'react', // errors caught by React ErrorBoundary
  internal: 'internal', // errors from internal systems or initialization
  third_party: 'third_party', // errors related to third-party libraries
};

export const LEVEL = {
  error: 'error',
  warn: 'warning',
  info: 'info',
};

export const PAGE_TYPE = {
  other: 'other',
  // checkout related
  plp: 'plp',
  pdp: 'pdp',
  cart: 'cart',
  checkout: 'checkout',
  confirm: 'confirm',
  fastCheckout: 'fastCheckout',
  expressCheckout: 'expressCheckout',
  onePageStoreCheckout: 'onePageStoreCheckout',
  promotions: 'promotions',
  // storefront related
  home: 'home',
  about: 'about',
  terms: 'terms',
  privacyPolicy: 'privacyPolicy',
  returnPolicy: 'returnPolicy',
  deliveryPolicy: 'deliveryPolicy',
  antiFraud: 'antiFraud',
  blog: 'blog',
  blogPost: 'blogPost',
  // customer related
  signIn: 'signIn',
  forgotPassword: 'forgotPassword',
  resetPassword: 'resetPassword',
  memberCenter: 'memberCenter',
  user: 'user',
  memberPoints: 'memberPoints',
  userCredits: 'userCredits',
  coupons: 'coupons',
  couponCenter: 'couponCenter',
  messages: 'messages',
  olp: 'olp',
  odp: 'odp',
  wishlist: 'wishlist',
};
